import React, { useState } from "react"
import "./template.css"
import ExpandToggle from "../../../shared/ExpandToggle/ui/ExpandToggle"
import TemplateSlot from "./TemplateSlot"
import Loading from "../../../../components/loading/loading"

/**
 * Программа (шаблон).
 */
const Template = ({
    originalTemplate,
    originalTitle,
    saveTemplate,
    isSending
}) => {
    const [template, setTemplate] = useState(originalTemplate)
    const [templateTitle, setTemplateTitle] = useState(originalTitle)
    const [isTemplateExpanded, setTemplateIsExpanded] = useState(false)

    const changeTemplateSlot = (slotIndex, field, value) => {
        const newTemplate = {...template}

        newTemplate.slots[slotIndex][field] = value

        setTemplate(newTemplate)
    }

    /**
     * Провалидирует данные программы перед сохранением.
     */
    const validateTemplate = () => {
        if (originalTitle !== templateTitle) {
            saveTemplate(template.slots, templateTitle)
        } else {
            saveTemplate(template.slots)
        }
    }

    const templateSettingsClasses = ["template-settings"]
    if (isTemplateExpanded) {
        templateSettingsClasses.push("template-settings--expanded")
    }

    const slots = template.slots

    return (
        <div className="template">
            <div className="template-title">{originalTitle}</div>

            <ExpandToggle
                isExpanded={isTemplateExpanded}
                setIsExpanded={setTemplateIsExpanded}
            />

            <div className={templateSettingsClasses.join(' ')}>
                <div>
                    <div className="general-title _mr">
                        Название программы
                    </div>
                    <input
                        type="text"
                        name="template-title"
                        className="input-title"
                        value={templateTitle}
                        onChange={(e) => setTemplateTitle(e.target.value)}
                    />
                </div>

                <TemplateSlot
                    title="Звон №1"
                    slot={slots[0]}
                    changeMelody={(value) => changeTemplateSlot(0, 'melody', value)}
                    changeRepeatCount={(value) => changeTemplateSlot(0, 'repeatCount', value)}
                    changeRepeatInterval={(value) => changeTemplateSlot(0, 'repeatInterval', value)}
                    changeTemplateDelay={(value) => changeTemplateSlot(0, 'templateDelay', value)}
                />

                <TemplateSlot
                    title="Звон №2"
                    slot={slots[1]}
                    changeMelody={(value) => changeTemplateSlot(1, 'melody', value)}
                    changeRepeatCount={(value) => changeTemplateSlot(1, 'repeatCount', value)}
                    changeRepeatInterval={(value) => changeTemplateSlot(1, 'repeatInterval', value)}
                    changeTemplateDelay={(value) => changeTemplateSlot(1, 'templateDelay', value)}
                />

                <TemplateSlot
                    title="Звон №3"
                    slot={slots[2]}
                    changeMelody={(value) => changeTemplateSlot(2, 'melody', value)}
                    changeRepeatCount={(value) => changeTemplateSlot(2, 'repeatCount', value)}
                    changeRepeatInterval={(value) => changeTemplateSlot(2, 'repeatInterval', value)}
                />

                <button
                    onClick={validateTemplate}
                    type="button"
                    className="template-setting__save"
                >
                    {!isSending && "Сохранить"}
                    {isSending && <Loading />}
                </button>
            </div>
        </div>
    )
}

export default Template